<template>
  <div :class="$style.frameGroup">
    <h2>{{ title }}</h2>
    <div :class="$style.frameContainer">
      <div :class="$style.buttonContainer">
        <div :class="$style.summaryButton" @click="openStudentInformationModal">
          <b>Summary of Sign Up Info</b>
        </div>
      </div>
      <div :class="$style.frameParent">
        <div :class="$style.offerAccepted">
          <div :class="$style.offerParent">
            <div :class="$style.groupParent">
              <img
                :class="$style.frameChild"
                alt=""
                src="/static/img/whitecheck.svg"
              />
              <div :class="$style.offerAcceptedWrapper">
                <b :class="$style.offerAccepted1">Offer Accepted</b>
              </div>
            </div>
            <div :class="$style.oneStepCloser">
              You’re one step closer to achieving your goals. Get started by
              submitting all required documents for quick processing. Funding
              approval takes just 72 hours!
            </div>
          </div>
          <div :class="$style.frameOfferContainer">
            <div :class="$style.aprEstWrapper">
              <div :class="$style.aprEst">
                <p :class="$style.label">
                  <b>11.58%</b>
                </p>
                <p :class="$style.label">APR Est.*</p>
              </div>
            </div>
            <img
              :class="$style.fmsbanklogo"
              alt=""
              src="/static/img/fmsbanklogo.png"
            />
            <img
              :class="$style.frameChild"
              alt=""
              src="/static/img/heart2.svg"
            />
          </div>
          <div :class="$style.offerContainer">
            <div :class="$style.moFor120MoWrapper">
              <div :class="$style.moFor120Container">
                <p :class="$style.label">
                  <b>$1,5565.65/mo</b>
                </p>
                <p :class="$style.for120Mo">For 120 mo*</p>
              </div>
            </div>
            <div :class="$style.interestAndFeesEstWrapper">
              <div :class="$style.interestAndFeesContainer">
                <p :class="$style.label">
                  <b>$76,881.20</b>
                </p>
                <p :class="$style.interestAndFees">Interest and Fees Est.*</p>
              </div>
            </div>
            <div :class="$style.loanAmountWrapper">
              <div :class="$style.loanAmount">
                <p :class="$style.label">
                  <b>$110,997</b>
                </p>
                <p :class="$style.loanAmount1">Loan Amount</p>
              </div>
            </div>
          </div>
          <img
            :class="$style.offerAcceptedChild"
            alt=""
            src="/static/img/info.svg"
          />
          <div :class="$style.offerAcceptedInner">
            <div :class="$style.offerDetailsParent">
              <b :class="$style.offerDetails">Offer Details</b>
              <div :class="$style.rectangleParent">
                <div :class="$style.frameInner" />
                <div :class="$style.length120Months">Loan Amount: $110,997</div>
              </div>
              <div :class="$style.rectangleParent">
                <div :class="$style.frameInner" />
                <div :class="$style.length120Months">
                  Length: 120 months (10 years)
                </div>
              </div>
              <div :class="$style.rectangleParent">
                <div :class="$style.frameInner" />
                <div :class="$style.length120Months">
                  APR (Estimated): 11.58%
                </div>
              </div>
              <div :class="$style.frameDiv">
                <div :class="$style.rectangleParent">
                  <div :class="$style.frameInner" />
                  <div :class="$style.length120Months">
                    Discounted percentages for autopay
                  </div>
                </div>
                <img
                  :class="$style.groupIcon"
                  alt=""
                  src="/static/img/info.svg"
                />
              </div>
              <div :class="$style.rectangleParent2">
                <div :class="$style.frameInner" />
                <div :class="$style.length120Months">
                  Deferment Period: 12 months before repayment begins.
                </div>
              </div>
            </div>
          </div>
          <div :class="$style.frameParent1">
            <div
              :class="$style.uploadDocumentsWrapper"
              @click="openUploadDocumentsPopUp"
            >
              <b :class="$style.length120Months">Upload Documents</b>
            </div>
            <div
              :class="$style.signLoanDocsWrapper"
              @click="openSignLoanDocsPopUp"
            >
              <b :class="$style.length120Months">Sign Loan Docs</b>
            </div>
            <div :class="$style.completeWrapper" @click="onFrameContainerClick">
              <b :class="$style.length120Months">Complete </b>
            </div>
          </div>
        </div>
      </div>
      <div :class="$style.buttonContainer">
        <div :class="$style.backButton" @click="$emit('onPrev')">
          <b>Back</b>
        </div>
      </div>
    </div>

    <PortalPopup
      overlayColor="rgba(113, 113, 113, 0.3)"
      v-show="showStudentModal"
      placement="Centered"
      @close="closeModal"
    >
      <StudentInformationModal :userId="userId" @close="closeModal" />
    </PortalPopup>

    <PortalPopup
      overlayColor="rgba(113, 113, 113, 0.3)"
      v-show="showDocumentModal"
      placement="Centered"
      @close="closeModal"
    >
      <UploadDocumentsModal @close="closeModal" />
    </PortalPopup>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import StudentInformationModal from "../Steps/StudentInformation.vue";
import UploadDocumentsModal from "../Steps/UploadDocuments.vue";
import PortalPopup from "../PortalPopup.vue";

export default defineComponent({
  components: {
    PortalPopup,
    StudentInformationModal,
    UploadDocumentsModal,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    userId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      showDocumentModal: false,
      showStudentModal: false,
    };
  },
  methods: {
    openUploadDocumentsPopUp() {
      this.showDocumentModal = true;
    },
    openStudentInformationModal() {
      this.showStudentModal = true;
    },
    closeModal() {
      this.showDocumentModal = false;
      this.showStudentModal = false;
    },
    openSignLoanDocsPopUp() {},
    onFrameContainerClick() {},
  },
});
</script>

<style module scoped>
.frameOfferContainer {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  padding: 0 33px 0 13px;
  gap: 0;
}
.offerContainer {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  padding: 0 20px;
  gap: 0;
  font-size: 18px;
  color: #676767;
}
.offerParent {
  align-self: stretch;
  border-radius: 15px 15px 0 0;
  background-color: #3c78ff;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 10px 20px;
  gap: 10px;
  font-size: 22px;
  color: #fff;
}
.oneStepCloser {
  align-self: stretch;
  position: relative;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.75);
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.offerDetailsParent {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 0 22px;
  gap: 20px;
}
.frameGroup {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.frameContainer {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 25px;
}
.buttonContainer {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.buttonContainer div {
  align-self: stretch;
  border-radius: 10px;
  height: 50px;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  cursor: pointer;
  color: #fff;
  transition: 0.2s ease-in-out;
}
.buttonContainer div:hover {
  opacity: 0.8;
}
.summaryButton {
  background-color: #3c78ff;
}
.backButton {
  background-color: #ccc;
}
.frameParent {
  position: relative;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  background-color: #fff;
  width: 100%;
  height: 780px;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  text-align: center;
  font-size: 15px !important;
  color: #fff;
  font-family: Helvetica, Arial, sans-serif;
}
.frameChild {
  width: 20px;
  position: relative;
  height: 20px;
}
.offerAccepted1 {
  flex: 1;
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.offerAcceptedWrapper {
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.groupParent {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
}
.label {
  margin: 0;
}
.aprEst {
  width: 74px;
  position: relative;
  display: inline-block;
}
.aprEstWrapper {
  width: 90px;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 5px 0;
  box-sizing: border-box;
}
.fmsbanklogo {
  width: 108px;
  position: relative;
  height: 47px;
  object-fit: cover;
}
.frameGroup {
  align-self: stretch;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0 0 0 0px;
}
.for120Mo {
  margin: 0;
  font-size: 16px;
  font-weight: 300;
  color: #000;
}
.moFor120Container {
  width: 131px;
  position: relative;
  display: inline-block;
}
.moFor120MoWrapper {
  width: 135px;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 5px 16px;
  box-sizing: border-box;
}
.interestAndFees {
  margin: 0;
  font-size: 16px;
  font-weight: 300;
}
.interestAndFeesContainer {
  width: 166px;
  position: relative;
  display: inline-block;
}
.interestAndFeesEstWrapper {
  width: 164px;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 5px 16px;
  box-sizing: border-box;
}
.loanAmount1 {
  margin: 0;
  font-weight: 300;
  color: #000;
}
.loanAmount {
  width: 111px;
  position: relative;
  display: inline-block;
}
.loanAmountWrapper {
  width: 110px;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 5px 16px;
  box-sizing: border-box;
  font-size: 16px;
}
.frameContainer {
  align-self: stretch;
  display: flex;
  justify-content: space-between;
  font-size: 18px;
  color: #676767;
}
.offerAcceptedChild {
  width: 507px;
  position: relative;
  height: 1px;
  object-fit: contain;
}
.offerDetails {
  width: 160px;
  position: relative;
  font-size: 18px;
  display: inline-block;
  color: #404040;
}
.frameInner {
  width: 10px;
  position: relative;
  background-color: #038d2f;
  height: 10px;
}
.rectangleParent {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
}
.length120Months {
  position: relative;
}
.groupIcon {
  width: 25px;
  position: relative;
  height: 25px;
}
.frameDiv {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 0;
}
.rectangleParent2 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  font-size: 17px;
}
.offerAcceptedInner {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.uploadDocumentsWrapper {
  align-self: stretch;
  border-radius: 10px;
  background-color: #fff;
  border: 1.5px solid #3c78ff;
  box-sizing: border-box;
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 10px 30px;
  cursor: pointer;
}
.signLoanDocsWrapper {
  align-self: stretch;
  border-radius: 10px;
  background-color: #fff;
  border: 1.5px solid #c3c3c3;
  box-sizing: border-box;
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 10px 30px;
  cursor: pointer;
  color: #bfbfbf;
}
.completeWrapper {
  align-self: stretch;
  border-radius: 10px;
  background-color: #3c78ff;
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 10px 30px;
  box-sizing: border-box;
  cursor: pointer;
  color: #fff;
}
.frameParent1 {
  align-self: stretch;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 5px 60px 20px;
  gap: 20px;
  font-size: 15px;
  color: #3c78ff;
}
.offerAccepted {
  width: 100%;
  position: relative;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  background-color: #fff;
  height: 780px;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
  text-align: left;
  font-size: 16px;
  color: #000;
  font-family: Helvetica, Arial, sans-serif;
}
p {
  font-size: 16px !important;
}
</style>
